import React, { useState, useEffect } from 'react'
import { Button, Form, Input, message, Select, } from 'antd';
import { infoPlayer, editPlayer } from '../../../http/modules/organization'
import './index.scss'
const { Option } = Select;

export default function XiuGai(props) {

    const { playerUUID,setPlayerId,OnListPlayer } = props

    // 参赛者详情
    const [course, setCourse] = useState()

    //课程详情
    const onInfoCourse = async () => {
        const res = await infoPlayer({
            playerUUID: playerUUID
        })
        if (res.code == 0) {
            setCourse(res.data.orgPlayer)
        }
    }

    useEffect(() => {
        onInfoCourse()
    }, [])

    const onFinish = async (values) => {
        const res = await editPlayer({
            "playerUUID":playerUUID, 
            "name":values.name,
            "gender":values.gender,
            "phone":values.phone,
            "work":values.work,
            "title":values.title,
            "email":values.email,
            "intro": values.intro,
        })
        if(res.code==0){
            message.success('修改成功')
            setPlayerId()
            OnListPlayer()
        }else{
            message.error('修改失败')
        }
     }

    return (
        <div className='personnelAdd'>
            <header>
                <p></p>
                修改参赛者信息
            </header>
            {course?  <Form
                name="basic"
                labelCol={{
                    span: 3,
                }}
                wrapperCol={{
                    span: 16,
                }}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    label="姓名"
                    name="name"
                    initialValue={course.name}
                    rules={[
                        {
                            required: true,
                            message: '请输入正确姓名!',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="性别"
                    name="gender"
                    initialValue={course.gender}
                    rules={[
                        {
                            required: true,
                            message: '请输入性别!',
                        },
                    ]}
                >
                    <Select
                        // placeholder={course?.gender}
                        allowClear
                    >
                        <Option key={'男'} value={'男'}>男</Option>
                        <Option key={'女'} value={'女'}>女</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="手机"
                    name="phone"
                    initialValue={course.phone}
                    rules={[
                        {
                            required: true,
                            message: '请输入正确的手机号!',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="职务"
                    name="work"
                    initialValue={course.work}
                    rules={[
                        {
                            required: true,
                            message: '请输入职务!',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="职称"
                    name="title"
                    initialValue={course.title}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="邮箱"
                    name="email"
                    initialValue={course.email}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="授课人/团队简介"
                    name="intro"
                    initialValue={course.intro}
                    rules={[{ max: 500, message: '简介最多500字' }]}
                >
                    <Input.TextArea
                        rows={4}
                        placeholder="介绍授课人/团队擅长领域、相关工作经历、所获资质证书、荣誉等。"
                        maxLength={500}
                        showCount
                    />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 3,
                        span: 6,
                    }}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                    <Button htmlType="button" onClick={()=>setPlayerId()}>
                        取消
                    </Button>
                </Form.Item>
            </Form>:''}
          
        </div>
    )
}
